/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

export const setShowRightSideBarToLocalStore = (value) => {
    localStorage.setItem("IsShowRightSideBar", value);
};

export const getShowRightSideBarFromLocalStore = () => {
    let value = false;
    if ("IsShowRightSideBar" in localStorage) {
        value = JSON.parse(localStorage.getItem("IsShowRightSideBar"));
    }
    return value;
};
